module.exports = __webpack_public_path__ + "static/media/Aalidhra13.8bf17535.jpg";